import { createApi } from '@aevue/components'
import { isNative, getMobileApiUrl } from './platform.js'

export const BASE_URL = (() => {
  const mobileApiUrl = getMobileApiUrl()
  if (isNative() && mobileApiUrl) return mobileApiUrl

  const origin = window.location.origin
  if (origin.includes('localhost') && import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }
  return origin
})()

export const api = createApi(BASE_URL)
